export const ACCESS_TOKEN = 'access-token';
export const REFRESH_TOKEN = 'refresh-token';
export const ICON_URL = '@/utils/icon-svg.js';
export const DEV = 'development'; //本地研发
export const PROD = 'production'; //生产环境
export const TEST = 'test'; //测试环境

export const PREFIX_URL = `${window.location.protocol}//${window.location.host}`;
export const PREFIX_WS_URL = `${window.location.protocol === 'http:' ? 'ws:' : 'wss:'}//${window.location.host}`;
